import Vue from 'vue';

Vue.filter('orderPurchaseType', function (purchaseType: string) {
  let label: string = '';
  switch (purchaseType) {
    case 'STOCK':
      label = 'In-stock';
      break;
    case 'PREORDER':
      label = 'Pre-order';
      break;
    case 'BUNDLING':
      label = 'Bundling';
      break;
    case 'UNLOCK':
    case 'UNLOCK_REPORT':
      label = 'Unlock';
      break;
    case 'UNLOCK_KIT':
      label = 'Unlock (Kit)';
      break;
    case 'SUBSCRIPTION':
      label = 'Subscription';
      break;
    case 'UNLOCK_PROTOCOL':
      label = 'Unlock Protocol';
      break;
    default:
      break;
  }
  return label;
});
